import { parseToken } from './parseToken';

export function isTokenExpiringSoon(token?: string): boolean {
  if (!token) {
    return false;
  }

  const jwtToken = parseToken(token);
  if (!jwtToken) {
    return false;
  }

  const { exp, iat } = jwtToken;

  return (exp - iat) / 2 + iat <= Date.now() / 1000;
}
